import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { emailSelector, isLoadingSelector, updateAppleEmailThunk, updateEmailError, updateEmailErrorMessage, } from '../appleUpdateEmailSlice.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
export const AppleUpdateEmailButton = () => {
    const { t } = useTranslation();
    const { value } = useAppSelector(emailSelector);
    const isLoading = useAppSelector(isLoadingSelector);
    const dispatch = useAppDispatch();
    const buttonLabel = t('loginregistration.twoStepLoginRegistration.appleUpdateEmail.button.continue');
    const { trackBtnClick, trackFieldError, trackFailedAttempt } = useTrack('twoStep');
    const verifyButtonClick = async () => {
        trackBtnClick({ uniqueName: 'continue' });
        const isValidEmail = validateEmail(value);
        if (!isValidEmail) {
            dispatch(updateEmailError(true));
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
            trackFieldError({ formFieldErrors: 'emailAddressNotValid' });
        }
        if (isValidEmail) {
            try {
                await dispatch(updateAppleEmailThunk(value)).unwrap();
            }
            catch (error) {
                const errorStatus = error?.status || 500;
                if (errorStatus === 409) {
                    trackFailedAttempt({
                        formFailedAttemptsErrors: 'emailAlreadyUsedError',
                    });
                }
                else {
                    trackFailedAttempt({
                        formFailedAttemptsErrors: 'otherGenericError',
                    });
                }
            }
        }
    };
    return (_jsx(Button, { "data-testid": "apple-update-continue-btn", variant: "primary", a11yLabel: "Continue button", type: "submit", onClick: verifyButtonClick, isLoading: isLoading, isFullWidth: true, marginTop: 'spaceL', size: ['medium'], children: buttonLabel }));
};
//# sourceMappingURL=AppleUpdateEmailButton.js.map